import { render, staticRenderFns } from "./DataAssetDIMContainer.vue?vue&type=template&id=e765ec42&"
import script from "./DataAssetDIMContainer.vue?vue&type=script&lang=js&"
export * from "./DataAssetDIMContainer.vue?vue&type=script&lang=js&"
import style0 from "./DataAssetDIMContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e765ec42')) {
      api.createRecord('e765ec42', component.options)
    } else {
      api.reload('e765ec42', component.options)
    }
    module.hot.accept("./DataAssetDIMContainer.vue?vue&type=template&id=e765ec42&", function () {
      api.rerender('e765ec42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataAssetDIMContainer.vue"
export default component.exports